"use strict";

var novicell = novicell || {}; // eslint-disable-line

novicell.login =
  novicell.login ||
  new (function () {
    this.init = function () {
      let loginForm = document.querySelector("#login-form");
      if (!loginForm) {
        return;
      }
      let displayFormBtn = document.querySelector(".email-address");
      let inputEmail = document.querySelector("#input-email");

      displayFormBtn.addEventListener("click", () => {
        
        loginForm.classList.remove("hide");
        displayFormBtn.classList.add("hide");
        inputEmail.focus();
      });
    };
  })();
